import { ReactElement, useState, useEffect } from 'react';

import { useTheme, Box, Button, Typography } from '@mui/material';

import { useElementSize } from 'usehooks-ts';

import Promo from './components/Promo';
import Spinner from './components/Spinner';
import { ProductModalProps } from './types';

import Center from '../../../../components/Center';
import Modal from '../../../../components/Modal';
import ModalHeader from '../../../../components/Modal/components/Header';

export default function ProductModal(props: ProductModalProps): ReactElement {
  const theme = useTheme();

  const [headerRef, { height: headerHeight }] = useElementSize();

  const { open, children, title, video, onClose, ...rest } = props;

  const [activeVid, setActiveVid] = useState<'spinner' | 'product' | null>('spinner');

  const handleSpinner = () => {
    if (video) {
      setActiveVid('product');
    } else {
      setActiveVid(null);
    }
  };

  const handleProduct = () => {
    setActiveVid(null);
  };

  useEffect(() => {
    if (open) {
      setActiveVid('spinner');
    }
  }, [open]);

  return (
    <Modal
      {...rest}
      fullScreen
      onClose={() => onClose()}
      open={open}
      sx={{ '& .MuiPaper-root': { backgroundColor: theme.palette.common.black } }}>
      <Center ref={headerRef}>
        <ModalHeader
          renderTitle={(props) => (
            <Typography {...props} color='grey.50'>
              {title}
            </Typography>
          )}
          sx={{ backgroundColor: 'transparent' }}
        />
      </Center>
      <Center width='100%' height={`calc(100vh - ${headerHeight}px)`}>
        {activeVid === 'spinner' ? (
          <Spinner onEnded={handleSpinner} />
        ) : activeVid === 'product' ? (
          <>
            <Promo video={video} onEnded={handleProduct} />
            <Box
              sx={{
                position: 'absolute',
                bottom: 16,
                left: '50%',
                zIndex: 1000,

                transform: 'translate(-50%, -50%)'
              }}>
              <Button
                color='secondary'
                onClick={() => handleProduct()}
                variant='text'
                sx={{ color: `${theme.palette.grey[50]} !important` }}>
                Skip video
              </Button>
            </Box>
          </>
        ) : (
          children
        )}
      </Center>
    </Modal>
  );
}
